export default __webpack_public_path__ + "static/media/java.065bcc9d.png";